<template>
  <div id="invoice">
    <div v-if="client" class="client">
      <div class="company">{{ client.company }}</div>
      <div v-if="client.with_regards_to" class="attn">
        {{ client.with_regards_to }}
      </div>
      <div class="vat">{{ client.VAT }}</div>
      <div class="address">
        <div class="street">
          {{ client.street }} {{ client.house_number }}
        </div>
        <div class="city">{{ client.postal_code }} {{ client.city }}</div>
        <div class="country">{{ client.country }}</div>
      </div>
    </div>
    <div class="own">
      <div class="address">
        <div class="street">{{ company.street }} {{ company.houseNumber }}</div>
        <div class="city">{{ company.postalCode }} {{ company.city }}</div>
        <div class="country">{{ company.country }}</div>
      </div>

      <div class="website">{{ company.website }}</div>
      <div class="email">{{ company.email }}</div>
      <div class="vat">{{ company.vat }}</div>
      <div class="account">{{ company.account }}</div>
    </div>
    <div class="content">
      <div class="detail">
        <div class="invoice-number">
          <div class="title">Invoice</div>
          <div class="number">{{ invoice.number }}</div>
        </div>
        <div class="dates">
          <div class="date">
            <label>Invoice date</label>
            <div class="value">{{ moment(invoice.date).format("YYYY / MM / DD") }}</div>
          </div>
          <div class="date">
            <label>Due date</label>
            <div class="value">{{ moment(invoice.date).add(invoice.payment_period, "d").format("YYYY / MM / DD")}}</div>
          </div>
        </div>
    </div>
      <div v-if="invoice.title" class="general-title">{{ invoice.title }}</div>
      <div v-if="invoice.articles" class="articles">
        <div class="article-layout legend">
          <div v-if="showDate" class="legend-item date">Date</div>
          <div class="legend-item description">Description</div>
          <div class="legend-item unit">Unit</div>
          <div class="legend-item price-unit">P/U</div>
          <div class="legend-item quantity">#</div>
          <div class="legend-item price">Price</div>
        </div>
        <div
          class="article-layout article"
          v-for="(article, index) of invoice.articles"
          :key="index"
        >
          <div v-if="moment(article.date).isValid()" class="date">
            {{ moment(article.date).format("YYYY / MM / DD") }}
          </div>
          <div class="article-item description">
            <div class="desc-1">{{ article.description }}</div>
            <div class="desc-2">{{ article.sub_description }}</div>
            <div class="desc-3">{{ article.third_description }}</div>
          </div>
          <div class="article-item unit">{{ article.unit }}</div>
          <div class="article-item price-unit">{{ article.price_unit }}</div>
          <div class="article-item quantity">{{ article.quantity }}</div>
          <div class="article-item price">
            {{ calculateArticleTotal(article) }}
          </div>
        </div>
      </div>
      <div class="totals">
        <div v-if="invoice.discount > 0" class="totals-item discount">
          <div class="label">{{ invoice.discount }}% discount</div>
          <div class="value">-{{ discount() }}</div>
        </div>
        <div class="totals-item sub-total">
          <div class="label">Subtotal</div>
          <div class="value">{{ subTotal() }}</div>
        </div>
        <div class="totals-item vat-percentage">
          <div class="label">{{ invoice.vat_percentage }}% VAT</div>
          <div class="value">{{ vat() }}</div>
        </div>
        <div class="totals-item total">
          <div class="label">Total</div>
          <div class="value">{{ total() }}</div>
        </div>
      </div>
      <div class="legal">terms and conditions <div>{{ company.legal}}</div> </div>
      <slot></slot>
    </div>
  </div>
</template>

<script>
import moment from "moment";
export default {
  name: "bonos-template-v1",
  props: ["invoice", "client", "user", "company", "url"],
  data() {
    return {
      moment: moment,
      subTotalWithoutDiscount() {
        let subTotal = 0;
        for (let article of this.invoice.articles) {
          subTotal += article.price_unit * article.quantity;
        }
        return +(Math.round(subTotal + "e+2") + "e-2");
      },
      discount() {
        if (this.invoice.discount) {
          return (this.subTotalWithoutDiscount() / 100) * this.invoice.discount;
        }
        return 0;
      },
      subTotal() {
        let subTotal = 0;
        if(this.invoice.articles){
          for (let article of this.invoice.articles) {
            subTotal += article.price_unit * article.quantity;
          }
        }
        return +(Math.round(subTotal - this.discount() + "e+2") + "e-2");
      },
      vat() {
        let vat = (this.subTotal() / 100) * this.invoice.vat_percentage;
        return +(Math.round(vat + "e+2") + "e-2");
      },
      total() {
        let total = this.subTotal() + this.vat();
        return +(Math.round(total + "e+2") + "e-2");
      },
    };
  },
  computed: {
    showDate() {
      for (let article of this.invoice.articles) {
        if (moment(article.date).isValid()){
          return true
        }
      }
      return false;
    }
  },
  methods: {
    calculateArticleTotal(article) {
      let articleTotal = article.price_unit * article.quantity;
      return +(Math.round(articleTotal + "e+2") + "e-2");
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../../styles/colors";

#invoice {
  position: relative;

  .client {
    position: absolute;
    left: 60px;
    top: 100px;
    font-size: 14px;
    .company {
      font-size: 16px;
      font-weight: 700;
    }
    .address {
      margin-top: 10px;
    }
  }
  .own {
    text-align: center;
    position: absolute;
    right: 120px;
    top: 150px;
    font-size: 14px;
    .address {
      margin: 0 0 10px 0;
    }
    .vat {
      margin-top: 10px;
    }
    .account {
      font-weight: 700;
    }
  }

  .content {
    padding-top: 350px;
    display: flex;
    flex-direction: column;
  }

  .detail {
    margin: 0 0 24px 60px;
    .invoice-number {
      display: flex;
      align-items: flex-end;
      .title {
        font-size: 18px;
        font-weight: 500;
        margin-right: 5px;
      }
      .number {
        font-size: 22px;
      }
    }
    .dates {
      margin-top: 10px;
      .date {
        display: flex;
        align-items: center;
        label {
          font-size: 10px;
          margin-right: 10px;
        }
        .value {
          font-size: 12px;
        }
      }
    }
  }

  .general-title {
    width: 100%;
    background: rgba(var(--color-invoice-theme-values), 0.6);
    text-align: center;
    padding: 5px 0;
    margin: 10px 0;
    font-size: 14px;
    font-weight: 700;
  }

  .articles {
    padding: 10px 60px;
    width: 21cm;
    box-sizing: border-box;
    .legend {
      margin-bottom: 20px;
    }
  }

  .discount {
    display: flex;
    align-items: center;
    .value {
      padding: 3px;
    }
  }
  .totals {
    right: 40px;
    bottom: 80px;
    position: absolute;
    .totals-item {
      text-align: right;
      display: flex;
      align-items: center;
      .label {
        font-size: 14px;
        width: 90px;
        margin-right: 5px;
      }
      .value {
        font-size: 14px;
        padding: 3px;
        text-align: right;
        width: 100px;
        &:after {
          content: "EUR";
          font-size: 10px;
          margin-left: 5px;

        }
      }
    }
    .discount {
      margin-bottom: 20px;
      color: var(--color-invoice-theme);

    }
    .total {
      margin-top: 10px;
      .value {
        font-size: 16px;
        font-weight: 700;
        color: var(--color-invoice-theme);
      }
    }
  }
  .legal {
    position: absolute;
    bottom: 24px;
    font-size: 10px;
    font-weight: 700;
    text-align: right;
    color: #999;
    right: 40px;

  }
}
.invoice-image-template {
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
}

.article {
  margin-top: 5px;
}

.article-layout {
  display: flex;
  width: 100%;
  .article-item {
    font-size: 16px;
    font-weight: 400;
  }
  .legend-item {
    font-size: 12px;
    font-weight: 700;
  }
  .date {
    font-size: 14px;
    width: 100px;
  }
  .description {
    flex-grow: 1;
    .desc-2 {
      font-size: 14px;
    }
    .desc-3 {
      font-size: 12px;
      font-weight: 700;
    }
  }
  .unit {
    width: 50px;
    text-align: center;
  }
  .price-unit {
    width: 75px;
    text-align: center;
  }
  .quantity {
    text-align: center;
    width: 60px;
  }
  .price {
    text-align: right;
    width: 75px;
  }
}

@media print {
  #invoice-template {
    border: none;
  }
}

</style>
